import { Skeleton } from '../../Skeleton'
import { useCalendarPreferences } from '../Calendar.hooks'
import { CalendarView } from '../CalendarView'

import * as styles from './CalendarTasksView.module.css'

function CalendarTasksView() {
  const { handleChangePreferences, isLoading, preferences } =
    useCalendarPreferences()

  function handleChangeMode(viewMode) {
    handleChangePreferences({ view_mode: viewMode })
  }

  return isLoading ? (
    <Skeleton className={styles.skeleton} />
  ) : (
    <CalendarView
      initialMode={preferences.view_mode}
      onChangeMode={handleChangeMode}
    />
  )
}

export default CalendarTasksView
